<template>
  <div class="migration-warning">
    <span class="tooltip tooltip-icon warning">!</span>
    <span class="warning-text">{{ warningObject.metadata.migrationWarning.details }}</span>
    <md-menu md-size="small">
      <md-button md-menu-trigger class="md-icon-button md-dense">
        <md-icon class="share-icon" style="color: white">more_vert</md-icon>
      </md-button>
      <md-menu-content>
        <md-menu-item :href="warningObject.metadata.migrationWarning.link" target="_blank">
          Watch video
        </md-menu-item>
        <md-menu-item href="#" @click="dismiss">Don't show again</md-menu-item>
      </md-menu-content>
    </md-menu>
  </div>
</template>

<script>
export default {
  name: 'migration-warning',
  props: {
    warningObject: {
      type: Object,
      required: true
    },
  },
  methods: {
    dismiss() {
      this.$emit('dismiss');
    }
  },
};
</script>

<style scoped>
.migration-warning {
  display: flex;
  align-items: center;
}

.tooltip-icon {
  position: relative;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  font-weight: bold;
  line-height: 22px;
  text-align: center;
  font-size: 15px;
  display: inline-block;
  cursor: pointer;
}

.tooltip-icon.warning {
  background-color: #f2994a;
  color: white;
}

.warning-text {
  margin-left: 8px;
}

.dismiss-item {
  cursor: pointer;
}
</style>
